<template>
  <div class="container lnb d_container">
    <div class="contents_wrap">
      <div class="contents list-container">
        <div class="title">
          {{ $route.meta.title }}

        </div>
        <div class="list-content">
          <ssam-talk-category-write-component :ssam-talk-type="'categoryUpdate'"
                                              :ssam-talk-key="ssamTalkKey"></ssam-talk-category-write-component>
          <div class="pa15 text-center btn_wrap">
            <el-button type="save" @click="save">저장</el-button>
            <el-button type="danger" @click="deleteCategory">삭제</el-button>
            <el-button  @click="$router.back()">목록</el-button>
          </div>
        </div>
      </div>
      <div class="footer-copyright">Copyright 2021. Peopleandtalk co.,Ltd. All rights reserved</div>
    </div>
  </div>
</template>

<script>


import SsamTalkCategoryWriteComponent from "@/components/ssamtalk/SsamTalkCategoryWriteComponent.vue";
import EventBus from "@/utils/event-bus";

export default {
  name: "SsamTalkCategoryDetail",
  mixins: [],
  components: {SsamTalkCategoryWriteComponent},
  provide() {
    return {};
  },
  props: {},
  data() {
    return {
      ssamTalkKey:this.$route.params.idx,
    };
  },
  created() {
  },
  mounted() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {},
  methods: {
    save(){
      EventBus.$emit('writeSsamTalkCategory');
    },
    deleteCategory(){
      EventBus.$emit('deleteSsamTalkCategory');
    }
  },
  watch: {},
};
</script>
